package one.healthium.profile.ui.profile

internal data class ProfileUiState(
    val loading: Boolean = false,
    val profile: ProfileUiModel? = null,
)
